/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-1",
    "aws_cognito_identity_pool_id": "us-east-1:059ffe2e-8c98-4280-b28b-4b05f8eda5f7",
    "aws_cognito_region": "us-east-1",
    "aws_user_pools_id": "us-east-1_DQQqRwxAx",
    "aws_user_pools_web_client_id": "4i061n7sqmqq9bongvmv26g9dt",
    "oauth": {},
    "aws_cognito_username_attributes": [],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL",
        "NAME",
        "NICKNAME"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "Auth": {
        "identityPoolId": "us-east-1:059ffe2e-8c98-4280-b28b-4b05f8eda5f7",
        "region": "us-east-1",
        "userPoolId": "us-east-1_DQQqRwxAx",
        "userPoolWebClientId": "4i061n7sqmqq9bongvmv26g9dt"
    },
    "API": {
        "endpoints": [
            {
                "name": "API",
                "endpoint": "https://1xtdlsbzob.execute-api.us-east-1.amazonaws.com/v2"
            }
        ]
    }
};


export default awsmobile;
